/*
 * SERPENTINA header behaviours (vanilla JS, no dependencies).
 *
 * 1. PC sub-menu opens on hover (LEGACY: header .js-subnavi mouseover/out). Dawn's <header-menu>
 *    <details> keeps its click / keyboard behaviour; hover only adds open/close on top of it.
 * 2. SP drawer accordion (LEGACY: .js-subnavi-sp click -> slideToggle). Markup lives in
 *    snippets/header-drawer.liquid ([data-sp-accordion] toggles an element referenced by aria-controls).
 * 3. Product-only predictive search (LEGACY: search form sent type=product). predictive-search.js is a
 *    stock Dawn file, so the request is narrowed here instead of editing it.
 */
(function () {
  'use strict';

  /* ---- 1. PC hover sub-menu ------------------------------------------------ */
  var hoverQuery = window.matchMedia ? window.matchMedia('(hover: hover) and (min-width: 990px)') : null;
  var CLOSE_DELAY = 160;

  function setOpen(details, open) {
    if (!details) return;
    var summary = details.querySelector('summary');
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
    }
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function initHover() {
    var items = document.querySelectorAll('.header__inline-menu header-menu');
    items.forEach(function (item) {
      var details = item.querySelector('details');
      if (!details) return;
      var timer = null;

      item.addEventListener('mouseenter', function () {
        if (!hoverQuery || !hoverQuery.matches) return;
        window.clearTimeout(timer);
        items.forEach(function (other) {
          if (other !== item) setOpen(other.querySelector('details'), false);
        });
        setOpen(details, true);
      });

      item.addEventListener('mouseleave', function () {
        if (!hoverQuery || !hoverQuery.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          setOpen(details, false);
        }, CLOSE_DELAY);
      });

      // A mouse click would toggle the menu shut right after the hover opened it.
      // Keyboard activation reports detail === 0 and keeps the native toggle.
      var summary = details.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (hoverQuery && hoverQuery.matches && event.detail > 0) event.preventDefault();
        });
      }
    });
  }

  /* ---- 2. SP drawer accordion --------------------------------------------- */
  function toggleAccordion(toggle) {
    var target = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!target) return;
    var expanded = toggle.getAttribute('aria-expanded') !== 'false';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    target.hidden = expanded;
  }

  function initAccordion() {
    document.querySelectorAll('[data-sp-accordion]').forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        toggleAccordion(toggle);
      });
      toggle.addEventListener('keydown', function (event) {
        if (event.key === ' ' || event.code === 'Space') {
          event.preventDefault();
          toggleAccordion(toggle);
        }
      });
    });
  }

  /* ---- 3. Product-only predictive search ---------------------------------- */
  function initProductOnlySearch() {
    if (!window.fetch || !window.routes || !window.routes.predictive_search_url) return;
    var originalFetch = window.fetch;
    var base = window.routes.predictive_search_url;

    window.fetch = function (input, init) {
      try {
        if (typeof input === 'string' && input.indexOf(base) === 0 && input.indexOf('resources') === -1) {
          input += (input.indexOf('?') === -1 ? '?' : '&') + 'resources[type]=product';
        }
      } catch (error) {
        // Fall through to the untouched request.
      }
      return originalFetch.call(this, input, init);
    };
  }

  initProductOnlySearch();

  function init() {
    initHover();
    initAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
